/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React icons

// Images

const globalCss = require("assets/theme/base/globals");

// Soft UI Dashboard PRO React context
import { useSoftUIController } from "context";

//let providers = [];

function Provider({ mode, initData, filterData, handleStepperButtonStatus, handleStepData }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, providers } = controller;

  const [enhancedProviders, setProviders] = useState(initData ? initData : []);
  const [selectedProvider, setProvider] = useState("");

  const css = globalCss ? globalCss.default : null;
  const customColors = css.customColors;

  async function setInitData() {
    //console.log("Wizard Providers step initData! ", initData);

    //providers = initData;
    for (let index = 0; index < initData.length; index++) {
      const provider = initData[index];
      initData[index].color = providers.find((p) => p.value == provider.id)["color"];
    }

    setProviders(initData);
  }

  if (filterData && selectedProvider === "" && initData) setSelectedProvider(filterData.id, false);

  const handleSetProvider = (e) => {
    e.preventDefault();
    //console.log(e.currentTarget.value);
    const providerId = parseInt(e.currentTarget.value);
    setSelectedProvider(providerId, true);
  };

  function setSelectedProvider(providerId, updateParent) {
    const provider = enhancedProviders.find((provider) => {
      return provider.id === providerId;
    });
    provider.selected = true;
    if (updateParent) {
      handleStepperButtonStatus(false);
      handleStepData(provider);
    }
    setProvider(providerId);
  }

  
  const mycustomButtonStyles = (data) => ({
    width: "150px",
    height: "120px",

    "&": {
      borderColor: customColors[data.name],
      backgroundColor: customColors[data.name + "-trans"],
      width: "150px",
      height: "120px",
    },
    "&:hover": {
      backgroundColor: customColors[data.name + "-hover"],
    },
    "&:focus": {
      borderColor: customColors[data.name],
      backgroundColor: customColors[data.name + "-focus"],
      border: "1px solid",
    },
    "&:disabled": {
      backgroundColor: customColors[data.name + "-disabled"],
      cursor: "not-allowed! important",
      pointerEvents: "all !important",
    },
    "& > p": {
      padding: "20px",
      backgroundColor: customColors[data.name],
      borderRadius: "50px",
      minWidth: "75px",
      boxShadow: "0px 0px 10px #fff",
    },
    "&:focus > p": {
      boxShadow: "none",
    },
  });

  useEffect(() => {
    setInitData();
  }, [initData]);

  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftBox mb={1}>
          <SoftTypography variant="h5" fontWeight="regular">
            Let&apos;s start by select the Provider you want the events from
          </SoftTypography>
        </SoftBox>
        <SoftTypography variant="body2" fontWeight="regular" color="text">
          Let us know the Provider you want to deliver to you
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3} justifyContent="center">
          {enhancedProviders.map((provider) => (
            <Grid item xs={12} sm={3} key={provider.id}>
              <SoftBox textAlign="center">
                <SoftButton
                  title={
                    !provider.enabled
                      ? "Another Filter already exist for this Provider!"
                      : provider.name
                  }
                  disabled={
                    provider.enabled
                      ? mode === "edit"
                        ? false
                        : !provider.enabled
                      : !provider.enabled
                  }
                  color="light"
                  variant={selectedProvider === provider.id ? "contained" : "outlined"}
                  value={provider.id}
                  onClick={handleSetProvider}
                  sx={mycustomButtonStyles(provider)}
                >
                  <SoftTypography
                    sx={{
                      fontFamily:
                        "-apple-system,BlinkMacSystemFont,Helvetica Neue,Segoe UI,Tahoma,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Open Sans,sans-serif",
                      // fontSize: "2rem",
                      fontWeight: "700",
                      // lineHeight: "2.2rem",
                      color: provider ? customColors[provider.name + "-icon-text"] : "inherit",
                    }}
                  >
                    {provider ? provider.name : ""}
                  </SoftTypography>
                  {/* <SoftAvatar src={provider.logo} alt={provider.name} size="xl" variant="rounded" /> */}
                </SoftButton>
                <div
                  title="Unified Feed"
                  style={{
                    display: provider.id === 1000 ? "" : "none",
                    position: "relative",
                    top: "-130px",
                    left: "75px",
                    scale: "160%",
                    color: "#cb0c9f",
                    textShadow: "1px 1px 2px #cecece",
                  }}
                >
                  <Icon>workspace_premium_icon</Icon>
                </div>
              </SoftBox>
            </Grid>
          ))}
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the DataTable
Provider.propTypes = {
  mode: PropTypes.string,
  initData: PropTypes.array,
  filterData: PropTypes.object,
  handleStepperButtonStatus: PropTypes.func,
  handleStepData: PropTypes.func,
};

export default Provider;
